import dayjs from '../../dayjsConfig'
import { ServiceProvider } from '../../services/api.types'
const convert = require('convert-units')

export const DATE_FORMAT = 'DD.MM.YYYY'

export function isNumberFieldErrorVisible(value?: string, isFormValid?: boolean, min?: number): boolean {
  const valueString = value || ''
  if (!min) min = 0

  return (parseInt(valueString, 10) < min || valueString.length === 0) && !isFormValid
}

export function isTextFieldErrorVisible(value: string, isFormValid = false): boolean {
  const valueString = value || ''

  return valueString.length === 0 && !isFormValid
}

export function isSelectFieldErrorVisible(value: any, isFormValid = false): boolean {
  return !value && !isFormValid
}

export function isEmailFieldErrorVisible(value: string, isFormValid = false): boolean {
  const regexp =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  return !regexp.test(value) && !isFormValid
}

export function isPasswordFieldErrorVisible(password: string, isFormValid = false, minimum = 6): boolean {
  const valueString = password || ''

  return valueString.length < minimum && !isFormValid
}

export function isConsentFieldErrorVisible(consent: string, isFormValid = false): boolean {
  return !consent && !isFormValid
}

export function isDateOfBirthErrorVisible(dateOfBirth: string, isFormValid = false): boolean {
  const now = dayjs()
  const validEarliestDob = dayjs().subtract(110, 'year')
  const dob = dayjs(dateOfBirth.trim(), 'DD.MM.YYYY', true)
  const isDobValid = dob.isValid()
  if (isDobValid && dob.isAfter(now)) {
    return true
  }
  if (isDobValid && dob.isBefore(validEarliestDob)) {
    return true
  }
  return !isDobValid && !isFormValid
}

export function isDateOfBirthValid(dateOfBirth: string): boolean {
  const now = dayjs()
  const validEarliestDob = dayjs().subtract(110, 'year')
  const dob = dayjs(dateOfBirth.trim(), 'DD.MM.YYYY', true)

  return dob.isValid() && dob.isBefore(now) && dob.isAfter(validEarliestDob)
}

export function convertFtInToCm(feet: number, inches: number): number {
  const ftCm = feet ? convert(feet).from('ft').to('cm') : 0
  const inCm = inches ? convert(inches).from('in').to('cm') : 0
  return ftCm + inCm
}

export function convertCmToFtIn(value: string): { heightFt: number; heightIn: number } {
  const heightFt = Math.floor(convert(value).from('cm').to('ft'))
  const heightCm = parseFloat(value) - convert(heightFt).from('ft').to('cm')
  const heightIn = Math.round(convert(heightCm).from('cm').to('in'))
  return { heightFt, heightIn }
}

export function precisionRoundMod(number: number, precision: number): number {
  const factor = Math.pow(10, precision)
  const n = precision < 0 ? number : 0.01 / factor + number
  return Math.round(n * factor) / factor
}

export function getServiceProviderLabel(serviceProvider: ServiceProvider): string {
  switch (serviceProvider) {
    case ServiceProvider.APPLE_HEALTH:
      return 'Apple Health'
    case ServiceProvider.HEALTH_CONNECT:
      return 'Health Connect'
    case ServiceProvider.FITBIT:
      return 'Fitbit'
    case ServiceProvider.GARMIN:
      return 'Garmin'
    case ServiceProvider.GOOGLE_FIT:
      return 'Google Fit'
    case ServiceProvider.HUAWEI:
      return 'Huawei'
    case ServiceProvider.POLAR:
      return 'Polar'
    case ServiceProvider.SUUNTO:
      return 'Suunto'
    default:
      return 'Unknown'
  }
}
